<template>
  <div>

    <FadeInOutComponent
      :key="fadeInModel"
      v-model:fadeInOutModel="fadeInModel"
      label="Fade In"
    />

    <FadeInOutComponent
      :key="fadeOutModel"
      v-model:fadeInOutModel="fadeOutModel"
      class="mt-4"
      label="Fade Out"
    />
  </div>
</template>

<script>
import FadeInOutComponent from "../FadeInOutComponent"

export default {
  name: 'VideoFadeTab',
  components: {
    FadeInOutComponent
  },
  props: {
    ffmpegData: {
      type: Object,
      required: true
    }
  },
  emits: ['update:ffmpegData'],
  computed: {
    fadeInModel: {
      get () {
        return this.ffmpegData.fade_in_model
      },
      set (val) {
        this.$emit('update:ffmpegData', {
          ...this.ffmpegData,
          fade_in_model: val
        })
      }
    },
    fadeOutModel: {
      get () {
        return this.ffmpegData.fade_out_model
      },
      set (val) {
        this.$emit('update:ffmpegData', {
          ...this.ffmpegData,
          fade_out_model: val
        })
      }
    }
  }
}
</script>

<style scoped>
</style>
